
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/job-descriptions/[jobDescriptionIdHash]",
      function () {
        return require("private-next-pages/job-descriptions/[jobDescriptionIdHash]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/job-descriptions/[jobDescriptionIdHash]"])
      });
    }
  